import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { BusinessField } from '../../../../@models';
import { DocFormFilterSelectComponent } from '../doc-form-filter-select/doc-form-filter-select.component';

@Component({
  selector: 'ngx-form-array-field',
  templateUrl: './form-array-field.component.html',
  styleUrls: ['./form-array-field.component.scss'],
})
export class FormArrayFieldComponent implements OnInit {
  @Input() title: string;
  @Input() options: { id: string, name: string }[];
  @Input() value: BusinessField[];
  @Input() selected: string;
  @Input() editor: boolean = true;
  @Input() placeholder: string;
  @Input() disabled: boolean = false;
  @Input() allBusinessOption: boolean = false;
  // eslint-disable-next-line max-len
  @Output() valueChange: EventEmitter<BusinessField[]> = new EventEmitter<BusinessField[]>();

  @ViewChild('business') businessView: DocFormFilterSelectComponent;

  array: { id: string, name: string }[] = [];
  _options: { id: string, name: string }[]

  dummyId = '000000000000000000003527';
  dummyName = '----- All -----';

  constructor() {
  }

  ngOnInit() {
    this._options = this.options;
    if (this.allBusinessOption) {
      this.options = [{id: this.dummyId, name: this.dummyName }, ...this.options];
      this.handleAllBusinessOption();
    }
    if (this.value && this.value[0] && this.value[0].id === this.dummyId) {
      this.array.push({ id: this.dummyId, name: this.dummyName });
    } else {
      this.value && this.value.map(m => {
        const opt = this._options.find(f => f.id === m.id);
        this.array.push({ id: ''+m.id, name: opt ? opt.name : '' });
      })
    }
    if (!this.value) this.value = [];
  }

  remove(item) {
    this.array = this.array.filter(f => f.id !== item.id);
    this.value = this.value.filter(f => f.id !== item.id);
    if (this.allBusinessOption) this.handleAllBusinessOption();
    this.valueChange.emit(this.value);
  }

  add() {
    if (this.selected && !this.array.find(f => f.id === this.selected )) {
      this.array.push(this._options.find(f => f.id === this.selected));
    }
    if (this.selected && !this.value.find(f => f.id === this.selected )) {
      this.value.push({ id: this._options.find(f => f.id === this.selected).id, checked: true});
    }
    if (this.allBusinessOption) this.handleAllBusinessOption();
    this.valueChange.emit(this.value);
  }

  handleAllBusinessOption() {
    if (this.value && this.value.length > 0) {
      this._options = this.options.filter(f => f.id !== this.dummyId)
    } else {
      this._options = this.options;
    }
  }

  expandSelect() {
    this.businessView.showPopup(true, true);
  }

}
